import React from "react";
import { Route, Switch,withRouter } from "react-router-dom"; 
import Header from "./Common/Header"; 
import PageNotFound from "./PageNotFound";
import OrderSearchPage from "./OrderSearch/OrderSearchPage";
import OrderDetailPage from "./OrderDetails/OrderDetailPage"; 
import LoginPage from './Login/LoginPage';
import StoreDesign from './Common/StoreDesign';
import OrderListingPage from './OrderListing/OrderListing';
import ReturnInstructions from "./OrderDetails/ReturnInstructions";
import {PRODUCTION_PATH} from '../AppConfig'

class ReturnsPortal extends React.Component{

/*constructor(props) {
           super(props);
            const { location } = this.props;
          }
 componentDidMount = () => {
    const pathSplit = location.pathname.split("/");
    if (pathSplit.length > 2 && pathSplit[2] === "FOHW_SHOPIFY") {
      window.location.replace("https://returns.fredericks.com/#/");
    }
  };*/
    
render() {   
  return (
    <div id="root">  
        <div className="content-wrap">
            <main id="main">
	            <div className="container"> 
                    <Header/> 
                    <StoreDesign/>
                        <Switch>        
                            <Route exact path={PRODUCTION_PATH+":store/ordersearch"} component={OrderSearchPage} /> 
                            <Route exact path={PRODUCTION_PATH+":store/orderdetails"} component={OrderDetailPage} /> 
                            <Route exact path={PRODUCTION_PATH+":store/login"} component={LoginPage} /> 
                            <Route exact path={PRODUCTION_PATH+":store/orderlisting"} component={OrderListingPage} />
                            <Route exact path={PRODUCTION_PATH+":store/returninstructions/:returnId?"} component={ReturnInstructions} />
                            <Route component={PageNotFound} />
                        </Switch>  
                    </div>
            </main>
        </div>
	</div>
  );
}
}

export default withRouter(ReturnsPortal);



// WEBPACK FOOTER //
// ./src/components/ReturnsPortal.js